export const loadState = (): any | undefined => {
  try {
    const serializedState = sessionStorage.getItem('reduxState')
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch {
    return undefined
  }
}

export const saveState = (state: { loanFlowReducer?: any, cardFlowReducer?: any, }): void => {
  try {
    const serializedState = JSON.stringify({
      loanFlowReducer: state.loanFlowReducer,
      cardFlowReducer: state.cardFlowReducer,
    })
    sessionStorage.setItem('reduxState', serializedState)
  } catch {
    // ignore quota errors
  }
}
